<template>
    <div class="BlogListItem">
        <div class="card">
            <div class="card-img-top">
                <blog-avatar :blog="blog" :w="600" :h="150"/>
            </div>
            <div class="card-body">

                <h4 class="card-title" @click.prevent="openBlog(blog, $event)" :title="blog.title">{{blog.title}}</h4>

                <div class="preview-cont">
                    <div class="inner">
                        <div v-for="p in posts"
                          @click.prevent="playPost(p)"
                          :style="{'background-image': bgImage(p.post.preview) }"
                          class="blogpost-img-preview"></div>
                    </div>
                </div>

            </div>
            <div class="card-footer">
                <a :href="getBlogUrl(blog)" @click.prevent="openBlog(blog, $event)" class="btn btn-outline-primary">show blog</a>
                <follow-button :blog="blog"/>
            </div>
        </div>

    </div>
</template>

<script>

    import BlogAvatar from '../ui/BlogAvatar.vue';
    import FollowButton from '../ui/buttons/FollowButton.vue';

    export default {
        name: '',
        props: ['blog'],
        data() {
            return {}
        },
        computed:{
            posts(){
                if(!this.blog.posts) return [];
                let posts = this.blog.posts.map((postRaw)=>{
                    let post = JSON.parse(JSON.stringify(postRaw));
                    post.blog = this.blog;
                    return post;
                });
                return posts;
            }
        },
        methods: {
            bgImage(img){
                return "url('"+img+"')";
            },
            playPost(post){
                this.$bus.$emit('playVideo', post);
            },
            openBlog(blog){
              this.$bus.$emit('blog-modal.open', {blog});
            },
            getBlogUrl(blog){
              return this.$router.resolve({name: 'BlogPage', params:{blogUrl:blog.url}}).href;
            },

        },
        components:{
            BlogAvatar,
            FollowButton
        }
    }
</script>

<style lang="sass" scoped>

    @import "../../assets/sass/vars"

    .BlogListItem
        width: 100%
        padding: 10px
        float: left

        @media screen and (min-width: $grid-md)
            width: 50%

        @media screen and (min-width: $grid-lg)
            width: 33.333333%

        @media screen and (min-width: $grid-xl)
            width: 25%

        .card
            box-shadow: 0 2px 4px rgba(0,0,0,.4)
            position: relative
            overflow: hidden
            border: 0

            .card-title
                text-align: center
                overflow: hidden
                height: 1.2em
                white-space: nowrap
                text-overflow: ellipsis

            .preview-cont
                padding-top: 60%
                position: relative

                .inner
                    position: absolute
                    height: 100%
                    width: 100%
                    top: 0px


            .blogpost-img-preview
                cursor: pointer
                padding-top: 30%
                width: 50%
                background-color: rgba(0,0,0,0.88)
                background-position: 50% 50%
                background-size: cover
                background-repeat: no-repeat
                display: block
                float: left
                transition: opacity .2s ease-in-out

                &:hover
                    opacity: .8


            .card-footer
                text-align: center


</style>



// WEBPACK FOOTER //
// src/components/blogs/BlogListItem.vue